import { ApiError, CommonService } from 'api-new/generated';
import { useQuery, UseQueryOptions } from 'react-query';

export const CommonLabourRateQueryKey = 'CommonLabourRateQueryKey';

export const useCommonLabourRateQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof CommonService.getCommonLabourRate>>,
      ApiError,
      Awaited<ReturnType<typeof CommonService.getCommonLabourRate>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) => useQuery([CommonLabourRateQueryKey, queryKey, [{}]], () => CommonService.getCommonLabourRate(), options);
